import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeServiceTypeCommand extends BaseCommand {
  CommandName = "ChangeServiceType";
  Command: {
    ServiceTypeId: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, serviceTypeId: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, ServiceTypeId: serviceTypeId };
  }
}
